import { createContext } from "react";

export const SessionContext = createContext<SessionContext | null>(null);
